import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import {
  createContext,
  FunctionComponent,
  ReactElement,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useSearchParams } from "react-router-dom";

export const GetBulkUserMonitoringRecordsContext = createContext(null);

type Props = {
  children: ReactElement;
};

const GetBulkUserMonitoringRecordsProvider: FunctionComponent<Props> = ({
  children,
}) => {
  const [queryParams, setQueryParams] = useSearchParams();
  const pageQuery = queryParams.get("page") || 1;

  const [pageNumber, setPageNumber] = useState(0);
  const [pageCount, setPageCount] = useState(0);

  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["user_monitoring_bulk_records", pageQuery],
    queryFn: async () => {
      const url = `user_monitoring/bulks?page_size=10&page=${
        Number(pageQuery) - 1 + 1
      }`;
      const { data } = await Api.get(`${url}`);
      return data;
    },
  });

  useEffect(() => {
    if (data) {
      setPageCount(Math.ceil(data?.metadata.count / 10));
    }
  }, [data]);

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
      pageNumber,
      pageCount,
      setPageNumber,
      pageQuery,
      setQueryParams,
      error,
    }),
    [
      data,
      isLoading,
      isFetching,
      pageNumber,
      pageCount,
      setPageNumber,
      pageQuery,
      setQueryParams,
      error,
    ],
  );
  return (
    <GetBulkUserMonitoringRecordsContext.Provider value={contextValue}>
      {children}
    </GetBulkUserMonitoringRecordsContext.Provider>
  );
};

export default GetBulkUserMonitoringRecordsProvider;
